// Generated by Jenkins (release-2026.10 #26, env=prod) - do not edit here.
export const API_CONFIG = {
  baseUrl: 'https://api.sale4all.co.il/',
  apiUrl: 'https://api.sale4all.co.il',
  wsUrl: 'wss://api.sale4all.co.il/ws/',
};
